import { Divider, SxProps, Typography } from "@mui/material";
import { ReactElement } from "react";
import { TalentSummaryCardContainer } from "../../talents/talentStyled";

type Props = {
  title?: string;
  children: ReactElement | ReactElement[];
  containerSx?: SxProps;
  divider?: boolean;
  disableDividerMargin?: boolean;
};

const TalentSummaryCard = ({
  title,
  containerSx = {},
  divider,
  children,
  disableDividerMargin = false,
}: Props) => (
  <TalentSummaryCardContainer sx={containerSx}>
    {title && (
      <>
        <Typography
          variant="header"
          sx={{
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "14px",
            paddingBottom: "12px",
          }}
        >
          {title}
        </Typography>
        {divider && (
          <Divider
            sx={{ marginBottom: disableDividerMargin ? "0px" : "5px" }}
          />
        )}
      </>
    )}
    {children}
  </TalentSummaryCardContainer>
);

export default TalentSummaryCard;
